import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RouterStoreEffects } from './router.effects';
import { StoreModule } from '@ngrx/store';
import { featureReducer } from './router.reducer';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('router', featureReducer),
    EffectsModule.forFeature([RouterStoreEffects])
  ]
})
export class RouterStoreModule { }
